import { SET_FILTER_SEARCH } from './../const';

export default (searchString) => {
    return {type: SET_FILTER_SEARCH, searchString};
}
